import React from 'react';
import Root from '@/root';
import { useImageEditorModel } from '@/store/models/image-editor-model';
import { checkImageEditor } from '@/utils/common';
import Contrast from './contrast';
import Helper from './help';

const Content = () => {
    const isImageEditor = checkImageEditor();
    const naturalImage = useImageEditorModel((state) => state.naturalImage);

    return (
        <>
            {/* 图片编辑器对比图 */}
            {isImageEditor && naturalImage ? <Contrast /> : null}
            {/* 帮助 */}
            <Helper />
        </>
    );
};

export const StageToolbar = React.memo(() => {
    return (
        <Root>
            <Content />
        </Root>
    );
});
